// Mermaid syntax generator for Flowise

export const generateMermaidCode = (nodes, connections) => {
  if (nodes.length === 0) {
    return '// Add nodes to generate Mermaid code\nflowchart TD';
  }

  let mermaid = 'flowchart TD\n';

  // Generate node definitions
  const nodeIdMap = {};
  nodes.forEach((node, index) => {
    const nodeId = `node${node.id}`;
    nodeIdMap[node.id] = nodeId;

    // Clean text for Mermaid (remove line breaks, escape special chars)
    const cleanText = node.text.replace(/\n/g, ' ').replace(/"/g, "'");

    // Generate node shape based on type
    let nodeDef;
    switch (node.type) {
      case 'rounded':
        nodeDef = `${nodeId}([${cleanText}])`;
        break;
      case 'diamond':
        nodeDef = `${nodeId}{${cleanText}}`;
        break;
      case 'parallelogram':
        nodeDef = `${nodeId}[/${cleanText}/]`;
        break;
      case 'rectangle':
      default:
        nodeDef = `${nodeId}[${cleanText}]`;
        break;
    }

    mermaid += `    ${nodeDef}\n`;
  });

  mermaid += '\n';

  // Generate connections
  connections.forEach(conn => {
    const fromId = nodeIdMap[conn.from];
    const toId = nodeIdMap[conn.to];

    if (fromId && toId) {
      if (conn.label && conn.label.trim()) {
        mermaid += `    ${fromId} -->|${conn.label}| ${toId}\n`;
      } else {
        mermaid += `    ${fromId} --> ${toId}\n`;
      }
    }
  });

  // Add styling
  mermaid += '\n    %% Styles\n';
  nodes.forEach(node => {
    const nodeId = nodeIdMap[node.id];
    if (node.color) {
      // Convert hex to a class-friendly format
      const colorClass = node.color.replace('#', '');
      mermaid += `    style ${nodeId} fill:${node.color},stroke:#333,stroke-width:2px\n`;
    }
  });

  return mermaid;
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy:', err);
    return false;
  }
};
